import type { AppState } from '@console/reducers';

export const getProjectDetailBulkDeliverables = (state: AppState) =>
  state.projectDetail.bulkDeliverables;
